export type ClientApiRequestResultError = {
    statusCode: number;
    message: string;
};

export type ClientApiRequestResult<T extends ApiResponse> = {
    /** If error is set then data may be undefined. */
    error?: ClientApiRequestResultError;
    data: Omit<T, "error">;
};

async function handleApiResonse<T extends ApiResponse>(url: string, res: Response): Promise<ClientApiRequestResult<T>> {
    const body = await res.text();

    // Dev env may throw this.
    if (res.status === 500 && body == "") {
        console.log("API error or offile!");
        return {
            error: {
                statusCode: 500,
                message: "API error or offile!",
            },
        } as ClientApiRequestResult<T>;
    }

    let status = res.status;
    let errorMsg: string | undefined;

    try {
        const data = JSON.parse(body) as T;
        if (status === 200) return { data };
        if (data.error) {
            errorMsg = data.error;
        } else {
            console.error("Data on invalid non-200 response:", data);
            errorMsg = "API did not respond with a success but also did not provide an error.";
        }
    } catch (error) {
        console.error(error);
        console.log("Body:");
        console.log(body);
        alert(`Could not parse API response: ${url} | ${res.status}\n\n${error}`);
        errorMsg = "Invalid response body received from API.";
        status = 500;
    }

    return {
        error: {
            statusCode: status,
            message: errorMsg,
        },
    } as ClientApiRequestResult<T>;
}

/**
 * Do API get request.
 * @param url
 * @returns
 */
export const apiGet = async <T extends ApiResponse>(url: string): Promise<ClientApiRequestResult<T>> => {
    const res = await fetch(url);
    return handleApiResonse(url, res);
};

/**
 * Do API post request.
 * @param url
 * @param body
 * @returns
 */
export const apiPost = async <T extends ApiResponse>(url: string, body: {} | []): Promise<ClientApiRequestResult<T>> => {
    const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    });
    return handleApiResonse(url, res);
};
